import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
    MatButtonModule, MatDividerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatSelectModule,
    MatTableModule, MatTabsModule, MatTooltipModule
} from '@angular/material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { ProjectDashboardComponent } from './project.component';
import { ProjectDashboardService } from './project.service';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { TableModule } from 'primeng/table';
import { MaterialModule } from 'app/shared/material.module';
// import { ProjectMetricsModule } from '../project-metrics/project-metrics.module';

const routes = [
    { path: '', redirectTo: 'projectdashboard', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'projectdashboard', component: ProjectDashboardComponent, resolve: { data: ProjectDashboardService }, canActivate: [AuthGuardService] },
];

@NgModule({
    declarations: [
        ProjectDashboardComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        MatTabsModule,
        NgxChartsModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseWidgetModule,
        TableModule,
        MatTooltipModule,
        MaterialModule,
        // ProjectMetricsModule
    ],
    providers: [
        ProjectDashboardService
    ],
    exports: [
        ProjectDashboardComponent
    ]
})
export class ProjectDashboardModule {
}

